import { Controller } from "stimulus"

export default class extends Controller {

  toggle() {
    const overlay = this.element.querySelector('[data-gl-template-target="overlay"]')
    if (overlay) overlay.classList.toggle('hidden')
  }

  async apply(event) {
    const templateId = event.currentTarget.value
    if (!templateId) return

    try {
      const applyUrl = this.data.get("applyUrlValue")
      const response = await fetch(applyUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'text/vnd.turbo-stream.html'
        },
        body: JSON.stringify({ template_transaction_id: templateId })
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
        this.close()
      }
    } catch (e) {
      console.error('Failed to apply template', e)
    }
  }

  close() {
    const overlay = this.element.querySelector('[data-gl-template-target="overlay"]')
    if (overlay) overlay.classList.add('hidden')
    // reset selection
    const select = this.element.querySelector('[data-gl-template-target="select"]')
    if (select) {
      select.value = ''
      // If SlimSelect initialized, try to reset its displayed text
      try {
        if (select.slim) { select.slim.set('') }
      } catch (e) { /* noop */ }
    }
  }
}
